import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Component, OnInit, inject } from '@angular/core'
import { FormsModule, NgForm } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

import { AuthenticationService } from '../../shared'

@Component({
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.css'],
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class SignInComponent implements OnInit {
    faSpinner = faSpinner
    isSigningIn = false
    public user = {
        username: '',
        password: '',
    }
    failedLogin = false
    lockedOut = false
    rateLimited = false
    sqlUnavailable = false
    showSessionExpiredMessage = false

    private http = inject(HttpClient)
    private router = inject(Router)
    private route = inject(ActivatedRoute)
    private authentication = inject(AuthenticationService)

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.showSessionExpiredMessage = params['sessionExpired'] === 'true'
        })
    }

    submitForm(form: NgForm) {
        this.failedLogin = false
        this.lockedOut = false
        this.rateLimited = false
        this.sqlUnavailable = false
        if (form.valid) {
            this.isSigningIn = true
            this.http.post<{ status?: string; succeeded?: boolean }>('api/Account/SignIn', this.user).subscribe({
                next: result => {
                    const status = result?.status
                    const succeeded = status === 'signedIn' || result?.succeeded === true
                    if (status === 'mfaEnrollmentRequired') {
                        this.router.navigate(['mfa-setup'])
                        return
                    }
                    if (status === 'mfaRequired') {
                        this.router.navigate(['mfa-verify'])
                        return
                    }
                    if (status === 'lockedOut') {
                        this.lockedOut = true
                        this.isSigningIn = false
                        return
                    }
                    if (!succeeded) {
                        this.failedLogin = true
                        this.isSigningIn = false
                        return
                    }
                    this.finishLogin()
                },
                error: (err: HttpErrorResponse) => {
                    this.isSigningIn = false
                    if (err.status === 503 && err.error?.error === 'sql_unavailable') {
                        this.sqlUnavailable = true
                    } else if (err.status === 429) {
                        this.rateLimited = true
                    } else {
                        this.failedLogin = true
                    }
                },
            })
        }
    }

    finishLogin() {
        this.authentication.completeLogin().subscribe({
            next: () => {
                if (this.authentication.requestedRoute) {
                    this.router.navigateByUrl(this.authentication.requestedRoute)
                    this.authentication.requestedRoute = ''
                } else {
                    this.router.navigate([''])
                }
            },
            complete: () => {
                this.isSigningIn = false
            },
        })
    }

    signup() {
        this.router.navigate(['signup'])
    }
}
